import { render, staticRenderFns } from "./SidebarPortfolio.vue?vue&type=template&id=14917719&scoped=true&"
import script from "./SidebarPortfolio.vue?vue&type=script&lang=ts&"
export * from "./SidebarPortfolio.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "14917719",
  null
  
)

export default component.exports